<scaffold-dialog [title]="'file_upload'|translation" [size]="'half'">
  <div scaffoldDialogBody>
    <div class="container" appFileDrop (fileDropped)="onFileDropped($event)">
      <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" />
      <i class="fas fa-cloud-upload-alt" style="font-size: 5rem;"></i>
        <div class="upload-label">{{'drag_and_drop_file'| translation}}</div>
        <div class="upload-label">{{'or'| translation}}</div> 
        <div class="upload-label"><span class="fake-link" (click)="fileDropRef.click()">{{'browse'| translation}}</span></div>
    </div>
    <div class="files-list">
      <div class="single-file" *ngFor="let file of files; let i = index">
        <div class="file-icon">
          <span [ngSwitch]="file.type">
            <i *ngSwitchCase="'image/jpeg'" class="fas fa-image"></i>
            <i *ngSwitchCase="'image/gif'" class="fas fa-image"></i>
            <i *ngSwitchCase="'image/png'" class="fas fa-image"></i>
            <i *ngSwitchCase="'application/x-zip-compressed'" class="fas fa-file-archive"></i>
            <i *ngSwitchCase="'application/pdf'" class="fas fa-file-pdf"></i>
            <i *ngSwitchDefault class="fas fa-file"></i>
          </span>
        </div>
        <div class="info">
          <h4 class="name">
            {{ file?.name }}
          </h4>
          <p class="size">
            {{ formatBytes(file?.size) }}
          </p>
          <p-progressbar [value]="file?.progress"></p-progressbar>
          <p *ngIf="file?.error">{{file?.error}}</p>
        </div>
        <div>
          <p-button variant="text" severity="contrast" (click)="deleteFile(i)" [pTooltip]="'upload_complete_click_to_hide'|translation" aria-label="Hide Upload" *ngIf="file?.progress==100 || file?.error">
            <i class="fas fa-check"></i>
          </p-button>
        </div>
      </div>

    </div>
  </div>
  <div scaffoldDialogButtons>
    <button pButton severity="secondary" (click)="close()">{{'done_uploading'| translation}}</button>
  </div>
</scaffold-dialog>
